import { ClearIcon } from './icons/clear';
import { OpenMeteoWeatherCode } from './types';

// Code References
const WeatherIconMeaning: Record<OpenMeteoWeatherCode, string> = {
  0: 'Clear sky',
  1: 'Mainly clear',
  2: 'Partly cloudy',
  3: 'Overcast',

  45: 'Fog',
  48: 'Depositing rime fog',

  51: 'Light drizzle',
  53: 'Moderate drizzle',
  55: 'Dense drizzle',
  56: 'Light freezing drizzle',
  57: 'Dense freezing drizzle',

  61: 'Slight rain',
  63: 'Moderate rain',
  65: 'Heavy rain',
  66: 'Light freezing rain',
  67: 'Heavy freezing rain',

  71: 'Slight snow fall',
  73: 'Moderate snow fall',
  75: 'Heavy snow fall',
  77: 'Snow grains',

  80: 'Slight rain showers',
  81: 'Moderate rain showers',
  82: 'Violent rain showers',

  85: 'Slight snow showers',
  86: 'Heavy snow showers',

  95: 'Thunderstorm',
  96: 'Thunderstorm with slight hail',
  99: 'Thunderstorm with heavy hail',
};

export function weatherCodeToCategory(code?: number | null): string {
  if (code == null) return 'Unknown';

  if (code === 0) return 'Clear';
  if ([1, 2, 3].includes(code)) return 'Cloudy';
  if ([45, 48].includes(code)) return 'Fog';
  if ([51, 53, 55, 56, 57].includes(code)) return 'Drizzle';
  if ([61, 63, 65, 66, 67].includes(code)) return 'Rain';
  if ([71, 73, 75, 77].includes(code)) return 'Snow';
  if ([80, 81, 82, 85, 86].includes(code)) return 'Showers';
  if ([95, 96, 99].includes(code)) return 'Thunderstorm';

  return 'Unknown';
}

/**
 * Returns the OpenWeatherMap icon code for an Open-Meteo weather code
 * @param code Open-Meteo weather code
 * @param isDay true if daytime, false if nighttime (optional)
 * Reference Icons: https://openweathermap.org/weather-conditions?collection=other
 */
export const weatherIcon = (code?: number | null, isDay: boolean = true) => {
  if (code == null) return 'na';

  const dayNight = isDay ? 'd' : 'n';
  const color = '#EC6E4C';
  return ClearIcon;
  // // Clear
  // // if (code === 0) return `01${dayNight}`;
  // if (code === 0) return <ClearIcon color={color} />;
  // // Cloudy
  // if ([1, 2, 3].includes(code)) return `03${dayNight}`; // partly/mostly cloudy
  // // Fog
  // if ([45, 48].includes(code)) return `50${dayNight}`; // mist/fog
  // // Drizzle
  // if ([51, 53, 55, 56, 57].includes(code)) return `09${dayNight}`; // drizzle
  // // Rain
  // if ([61, 63, 65, 66, 67].includes(code)) return `10${dayNight}`; // rain
  // // Snow
  // if ([71, 73, 75, 77].includes(code)) return `13${dayNight}`; // snow
  // // Showers (rain or snow showers)
  // if ([80, 81, 82, 85, 86].includes(code)) return `09${dayNight}`; // showers / rain
  // // Thunderstorm
  // if ([95, 96, 99].includes(code)) return `11${dayNight}`; // thunderstorm
  // // fallback
  // return 'na';
};
